import Container from "@/components/common/Container";
import Behance from "@/components/svg/Behance";
import Dribbble from "@/components/svg/Dribbble";
import Instagram from "@/components/svg/Instagram";
import Pinterest from "@/components/svg/Pinterest";
import Image from "next/image";
import Link from "next/link";


const Design = (data) => {
  const { designImgList, title } = data.design;
  return (
    <Container large className="pt-10 lg:pt-40">
      <div className="flex flex-col md:flex-row">
        <div className="md:w-1/2">
          <h2 className="font-medium text-4xl md:text-3xl lg:text-6xl mb-0 pb-10 md:pb-0">
            <span dangerouslySetInnerHTML={{ __html: title }}></span>
          </h2>
        </div>
        <div className="flex items-center md:justify-end md:w-1/2">
          <Link href="https://www.behance.net/ultroneous">
            <a target="_blank" className="mr-12 md:mr-8">
              <Behance
                fill="black"
                className="hover:fill-primary-yellow"
                width={32}
                height={20}
              />
            </a>
          </Link>
          <Link href="https://dribbble.com/ultroneous">
            <a target="_blank" className="mr-12 md:mr-8">
              <Dribbble
                fill="black"
                className="hover:fill-primary-yellow"
                width={29}
                height={28}
              />
            </a>
          </Link>
          <Link href="https://www.instagram.com/ultroneous.technologies/">
            <a target="_blank" className="mr-12 md:mr-8">
              <Instagram
                className="hover:fill-primary-yellow"
                fill="black"
                height={29}
                width={29}
              />
            </a>
          </Link>
          <Link href="https://in.pinterest.com/ultroneoustechnologies/">
            <a target="_blank">
              <Pinterest
                className="hover:fill-primary-yellow"
                fill="black"
                height={31}
                width={28}
              />
            </a>
          </Link>
        </div>
      </div>
      <div className="flex flex-col md:flex-row flex-wrap gap-y-8 pt-20">
        {designImgList.map((item) => (
          <div key={item.image} className="md:w-4/12 px-3">
            <Image
              alt={item.name}
              className="transition-all duration-700 ease-out hover:scale-110"
              height={500}
              src={item.image}
              width={500}
            />
          </div>
        ))}
      </div>
    </Container>
  );
};
export default Design;
